// extracted by mini-css-extract-plugin
export default {"numericInputWrap":"Suj1KUCNlIGkyuIK2d3C","label":"R5Z5osEXj5r2IgxxL7QP","numericInput":"CPZXe6obTHf5d7R527Uk","errorMsg":"aUXFZjpts1DjJWkXVjeq","infoMsg":"GhxQjSb5CtnQBO8_PdUQ"};